import { useMemo, useRef } from 'react'
import debounce from 'lodash/debounce'

const DEFAULT_DEBOUNCE_MS = 800

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type LoadOptionsFn = (input: string, callback: any) => void

export const useDebouncedLoadOptions = (loadOptions: LoadOptionsFn, delay = DEFAULT_DEBOUNCE_MS) => {
  const loadOptionsRef = useRef(loadOptions)
  loadOptionsRef.current = loadOptions

  const debouncedLoadOptions = useMemo(
    () =>
      debounce((input: string, callback: any) => {
        loadOptionsRef.current(input, callback)
      }, delay),
    [delay]
  )

  return debouncedLoadOptions
}
